import { Typography } from 'modules/v2/foundation/Typography';
export function AvatarListHeader(props) {
    const { title } = props;
    return (<Typography $fontSize="small" $fontWeight="bold">
      {title}
    </Typography>);
}
